import type { ReactNode } from 'react';
import * as icons from '../icon/assets';
import { Icon } from '../icon/icon';

interface BannerProps {
  type: 'information' | 'warning' | 'critical';
  content: ReactNode;
  icon?: boolean;
  link?: string;
}

export function Banner({ type, content, icon, link }: BannerProps) {
  const iconMap: Record<string, keyof typeof icons> = {
    information: 'InfoCircleFilled',
    warning: 'AlertTriangleFilled',
    critical: 'AlertTriangleFilled',
  };
  const backgroundColorMap = {
    information: 'var(--surface-surface-blue-tint)',
    warning: 'var(--surface-surface-yellow-tint)',
    critical: 'var(--surface-surface-red-tint)',
  };

  const colorMap = {
    information: 'var(--icon-icon-blue)',
    warning: 'var(--icon-icon-yellow)',
    critical: 'var(--icon-icon-red)',
  };

  return (
    <div
      className={`flex items-center gap-2 px-4 py-3 rounded-[8px]`}
      style={{ backgroundColor: backgroundColorMap[type] }}
      onClick={() => {
        if (link) {
          window.open(link, '_blank');
        }
      }}
    >
      {icon && (
        <Icon
          name={iconMap[type]}
          size={20}
          color={colorMap[type]}
          wrapperStyle={{ alignSelf: 'flex-start' }}
        />
      )}
      <span
        className={`flex-grow text-size-6 font-regular leading-font-height-5 tracking-[-0.1px] text-[${colorMap[type]}]`}
      >
        {content}
      </span>
      {link && <Icon name='ChevronRight' size={20} color={colorMap[type]} />}
    </div>
  );
}
